// src/pages/agencies/Agencies.jsx

import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import AgenciesTable from "../../components/agencies/AgenciesTable";

const Agencies = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <AgenciesTable />
        </WrapperSection>
    );
};

export default Agencies;
